import { styled } from "../../../styles";

/** Retool's `generationsMultiselect`, as a row of checkboxes. */
export const GenerationOptions = styled("div", {
  display: "flex",
  gap: "16px",
  alignItems: "center",
});

/** Chip list of the generations a firmware is offered to. */
export const GenerationTags = styled("span", {
  display: "inline-flex",
  flexWrap: "wrap",
  gap: "4px",
});

export const GenerationTag = styled("span", {
  padding: "1px 8px",
  borderRadius: "10px",
  backgroundColor: "$gray-20",
  border: "1px solid $gray-30",
  fontSize: "12px",
  fontFamily: "$openSans",
  color: "$charcoal",
  whiteSpace: "nowrap",
});

/** The binary link in the table; falls back to plain text with no URL. */
export const BinaryLink = styled("a", {
  color: "$primary",
  fontSize: "13px",
  fontFamily: "$openSans",
  wordBreak: "break-all",

  "&:hover": { textDecoration: "underline" },
});
